<style lang="sass">
@import ../../common/styles/mixins
@import ../../common/styles/settings
@import form-satisfaction
@import form-satisfaction__locator

</style>

<script>
    export default {

        props: {
            dataProps: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                location: false,
                success: false,
                marker: '',
                formEl: null,
                formError: '',
                formData: {
                    email: '',
                    retailer: '',
                    location: '',
                    rate_length: 0,
                    rate_quality: 0,
                    rate_reference: 0
                },
                retailersLabels: []
            }
        },

        computed: {
            displayNext () {
                return this.formData.location !== '' && !this.location
            },
            displaySubmit () {
                return this.mode.gazissimo || this.location
            },
            mode () {
                return {
                    gazissimo: this.formData.retailer === 'gazissimo',
                    retailer: this.formData.retailer !== '' && this.formData.retailer !== 'gazissimo'
                }
            }
        },

        created () {
            let props = JSON.parse(this.dataProps)
            this.formData.email = props.email ? props.email : 'test@test.fr'
            this.retailersLabels = props.retailers
            this.marker = props.marker
        },

        mounted () {
            this.formEl = this.$el.querySelector("form")
            this.success = this.formEl.querySelector(".webform-confirmation") !== null

            this.getLocator()
        },

        methods: {
            next() {
                this.location = true
            },
            back() {
                this.location = false
            },
            getLocator () {

                const host = window.location.host,
                      path = (host !== 'www.finagaz.fr' && host !== 'www.finagaz-pp.finagaz.fr')
                          ? 'localhost:9000'
                          : host

                let script = document.createElement('script')

                script.type = 'text/javascript'
                script.src = 'https://bridge-widget.v3.leadformance.com/release/v1.0.1/bridge-widget.js'
                script.setAttribute('data-api-key', '5a990d0db7e56000175b3ec2_04554f86-b231-469b-a888-c4a54c125827')
                script.setAttribute('data-api-secret', '6fb24f01-12b2-4065-a053-d758095332ec')
                script.setAttribute('data-custom-style-url', `https://${path}/themes/finagaz/css/bundle.css`)
                script.setAttribute('data-locale', 'fr')
                script.setAttribute('data-map-api-key', 'AIzaSyCqDFTp6Q-3C_tGnGYT2TkZXDrIJTw5N9s')
                script.setAttribute('data-map-marker', this.marker)
                script.setAttribute('data-map-provider', 'googleMap')
                script.setAttribute('data-search-geolocation', 'true')
                script.setAttribute('data-search-placeholder', 'Code postal ou ville')
                script.setAttribute('data-target', `#${this.$refs.locator.id}`)

                script.onload = (e) => this.onScriptLoad()

                document.head.appendChild(script)
            },
            onScriptLoad (el) {

                let iframe, widget

                const observer = new MutationObserver(mutations => {

                    let record = mutations.find(m => m.type === 'childList')

                    if(record.addedNodes.length > 0) {
                        record.addedNodes.forEach(n => {
                            if (n.nodeName === 'DIV' && n.className === 'search-results') {
                                let locations = n.querySelectorAll('.search-result') || []
                                if(locations.length > 0) {
                                    locations.forEach(l => {
                                        let locationName = (l.querySelector('.location-name-label') || {}).textContent
                                        l.appendChild(this.getLocationButton( locationName ))
                                    })
                                }
                            }
                        })
                    }
                })

                iframe = this.$refs.locator.querySelector('iframe')

                const checkWidget = () => {
                    widget = iframe.contentDocument.querySelector('.widget')
                    if(widget !== null)
                        observer.observe(widget, { childList: true })
                    else
                        requestAnimationFrame(checkWidget)

                }
                requestAnimationFrame(checkWidget)

            },
            getLocationButton ( name ) {
                let button = document.createElement('button')
                    button.classList.add('location-select')
                    button.innerHTML = 'Sélectionner'
                    button.addEventListener('click', (e) => this.updateFormData({location: name}))

                return button
            },
            setLocatorEvents (locator) {
                let locations = locator.querySelectorAll('.search-result')
            },
            updateFormData(data) {
                this.formData = {...this.formData, ...data}
            },
            submit () {
                this.$validator.validateAll().then(result => {
                    if (result) {
                        this.fillForm()
                        this.formEl.submit()
                    }
                })
            },
            fillForm () {
                for (let [key, value] of Object.entries(this.formData)) {
                    let inputs = this.formEl.querySelectorAll(`[name='${key.toLowerCase()}']`)
                    switch (key) {
                        case 'retailer':
                            inputs.forEach((i, k) => {
                                if (i.value === value)
                                    i.setAttribute('checked', 'checked')
                            })
                            break
                        default:
                            inputs[0].value = value
                            break
                    }
                }
            }
        }
    }
</script>